import React from "react";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";

const AddModifyButton = ({
  onClick,
  buttonText = "Add/Modify Question",
  className = ""
}) => {
  return (
    <CustomButton
      buttonType="button"
      variant="ok"
      buttonText={buttonText}
      className={`text-[16px] font-normal h-[50px] w-[200px] ${className}`}
      onClick={onClick}
    />
  );
};

export default AddModifyButton;
